var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplatePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 119,
    viewBox: "0 0 176 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.52731,
    y: 0.331998,
    width: 174.945,
    height: 33.2445,
    rx: 7.97532,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.167901
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75439 4.44558C1.75439 2.12735 3.63369 0.248047 5.95193 0.248047H170.236C172.554 0.248047 174.433 2.12735 174.433 4.44558H1.75439Z",
    fill: "#4A9A8C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.81104,
    y: 9.65039,
    width: 81.2826,
    height: 7.21976,
    rx: 3.60988,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.81104,
    y: 22.0752,
    width: 162.378,
    height: 3.86173,
    rx: 1.93087,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.52731,
    y: 36.6054,
    width: 174.945,
    height: 25.15,
    rx: 7.97532,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 42.2432,
    width: 124.804,
    height: 5.72165,
    rx: 2.86083,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 52.2559,
    width: 128.077,
    height: 3.86173,
    rx: 1.93087,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 52.2559,
    width: 11.73,
    height: 3.86173,
    rx: 1.93087,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8686,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7304,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5922,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 59.454,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3153,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 79.1771,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 89.039,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#4A9A8C",
    strokeWidth: 0.503704
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7944,
    y: 53.2637,
    width: 1.84692,
    height: 1.84692,
    rx: 0.923458,
    fill: "#4A9A8C"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9008,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 108.763,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 118.624,
    y: 52.5077,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 128.234,
    y: 52.2559,
    width: 11.73,
    height: 3.86173,
    rx: 1.93087,
    fill: "#D9D9D9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.52731,
    y: 36.6054,
    width: 174.945,
    height: 25.15,
    rx: 7.97532,
    stroke: "#D9D9D9",
    strokeWidth: 0.167901
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 0.52731,
    y: 64.7841,
    width: 174.945,
    height: 25.15,
    rx: 7.97532,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 70.4219,
    width: 124.804,
    height: 5.72165,
    rx: 2.86083,
    fill: "#D9D9D9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 80.4346,
    width: 128.077,
    height: 3.86173,
    rx: 1.93087,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 80.4346,
    width: 11.73,
    height: 3.86173,
    rx: 1.93087,
    fill: "#D9D9D9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8686,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7304,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5922,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#4A9A8C",
    strokeWidth: 0.503704
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3477,
    y: 81.4424,
    width: 1.84692,
    height: 1.84692,
    rx: 0.923458,
    fill: "#4A9A8C"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 59.454,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3153,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 79.1771,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 89.039,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9008,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 108.763,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 118.624,
    y: 80.6864,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 128.234,
    y: 80.4346,
    width: 11.73,
    height: 3.86173,
    rx: 1.93087,
    fill: "#D9D9D9"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 0.52731,
    y: 64.7841,
    width: 174.945,
    height: 25.15,
    rx: 7.97532,
    stroke: "#D9D9D9",
    strokeWidth: 0.167901
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 0.52731,
    y: 92.9629,
    width: 174.945,
    height: 25.15,
    rx: 7.97532,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 98.6006,
    width: 124.804,
    height: 5.72165,
    rx: 2.86083,
    fill: "#D9D9D9"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 108.613,
    width: 128.077,
    height: 3.86173,
    rx: 1.93087,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8867,
    y: 108.613,
    width: 11.73,
    height: 3.86173,
    rx: 1.93087,
    fill: "#D9D9D9"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8686,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7304,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5922,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 59.454,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3153,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 79.1771,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 89.039,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9008,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 108.763,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.503704
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 118.624,
    y: 108.865,
    width: 3.35803,
    height: 3.35803,
    rx: 1.67901,
    fill: "white",
    stroke: "#4A9A8C",
    strokeWidth: 0.503704
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 119.379,
    y: 109.621,
    width: 1.84692,
    height: 1.84692,
    rx: 0.923458,
    fill: "#4A9A8C"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 128.234,
    y: 108.613,
    width: 11.73,
    height: 3.86173,
    rx: 1.93087,
    fill: "#D9D9D9"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 0.52731,
    y: 92.9629,
    width: 174.945,
    height: 25.15,
    rx: 7.97532,
    stroke: "#D9D9D9",
    strokeWidth: 0.167901
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatePreview);
export default __webpack_public_path__ + "static/media/template-preview.186a05020350d35a254af63b9436d509.svg";
export { ForwardRef as ReactComponent };